import React, { useEffect, useRef, useState } from 'react';
import BubbleButton from './BubbleButton';
import './BubbleDrawer.scss';

export type BubbleDrawerPosition = 'left' | 'right';

interface BubbleDrawerPropsBase {
  hideTools?: boolean;
  className?: string;
  containerClassName?: string;
  onClose?: () => void;
}

export type BubbleDrawerProps = React.HTMLAttributes<HTMLDivElement> & BubbleDrawerPropsBase;

export default function BubbleDrawer(props: BubbleDrawerProps) {
  const {
    // from component
    hideTools,
    containerClassName: propContainerClasses,
    onClose,
    // from div
    className: propClasses,
    ...rest
  } = props;

  const [position, setPosition] = useState('right');
  const drawerRef = useRef<HTMLDivElement>(null);

  const classes = ['bubble-drawer'];
  if (propClasses) classes.push(propClasses);

  const containerClasses = ['drawer-container'];
  if (propContainerClasses) containerClasses.push(propContainerClasses);

  let containerStyle: React.CSSProperties = {};
  if (position === 'left') {
    containerStyle.left = 0;
  } else {
    containerStyle.right = 0;
  }

  useEffect(() => {
    if (drawerRef.current) drawerRef.current.focus();
  }, [drawerRef]);

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className="drawer-backdrop" onClick={props.onClose} tabIndex={0} ref={drawerRef}>
        {!props.hideTools && (
          <div className={`p-3 ${position === 'left' ? 'text-right' : 'text-left'}`}>
            <BubbleButton
              variant="white"
              icon="arrows-left-right"
              onClick={() => {
                setPosition(position === 'left' ? 'right' : 'left');
              }}
            />
          </div>
        )}
      </div>
      <div className={containerClasses.join(' ')} style={containerStyle}>
        {props.children}
      </div>
    </div>
  );
}
